export default __webpack_public_path__ + "static/media/12-32-13 2.7a702be3.jpg";